export const themes = {
  default: {
    thDay:
      'cursor-pointer flex-1 flex flex-col items-center justify-center md:h-25 h-13 p-1 text-base text-center transition-all border-t border-r border-gray-light relative',
    thDayNumber: 'md:absolute top-0 left-0 md:p-1 text-xs md:text-sm font-normal',
    thDayPrice: 'text-sm md:text-md',
    thStatusMessage: 'hidden md:inline font-normal',
    thFrom: 'hidden md:inline font-normal',
  },
  compact: {
    thDay:
      'cursor-pointer flex flex-1 flex-col items-center justify-start h-9 leading-tight p-1 text-base text-center',
    thDayNumber: '',
    thDayPrice: 'mx-auto self-end block font-hairline text-xs',
    thStatusMessage: 'hidden',
    thFrom: 'hidden',
  },
};
